export const SEARCH = "search";

export const BROWSE = "browse";

export const VIEW_VIDEO_VEILED_TOP = "viewVideoVeiledTop";

export const VIEW_VIDEO_VEILED_BOTTOM = "viewVideoVeiledBottom";

export const VIEW_VIDEO_VEILED_BOTTOM_POST_TRIAL =
  "viewVideoVeiledBottomPostTrial";

export const VIEW_ARTICLE_VEILED_TOP = "viewArticleVeiledTop";

export const VIEW_ARTICLE_VEILED_BOTTOM = "viewArticleVeiledBottom";

export const VIEW_ARTICLE_VEILED_BOTTOM_POST_TRIAL =
  "viewArticleVeiledBottomPostTrial";

export const VIEW_ARTICLE_VEILED_BOTTOM_UNAUTHENTICATED =
  "viewArticleVeiledBottomUnauthenticated";

export const ADMIN_CONSOLE_ADMIN_TOOLS_CONTENT_SETTINGS =
  "adminConsoleAdminToolsContentSettings";

export const CAREGIVER_SUFFIX = "Caregiver";
